import React from 'react'
import {PiNuclearPlant} from "react-icons/pi";
import {IoMdSchool} from "react-icons/io";
import {GiMechanicalArm} from "react-icons/gi";
import {GiDeliveryDrone} from "react-icons/gi";
import {TbAutomaticGearbox} from "react-icons/tb";

const homeConfig = {

    greeting:
        <h1 className="heading">
            <strong className="main-name">Hi! I'm Zephyr Conley</strong>
        </h1>,
    titles: [
        "A Roboticist",
        "An Automation Engineer",
        "A Mechanical Engineer",
        "An Eternally Curious Person",
        "A Writer",
        "A Flutist"
    ],
    about: {
        start: "I am an Automation Engineer working in the fiber optics industry." +
                " In my current job my role is to support assemblers in the line by designing hands-free automated solutions that eliminate time and labor-intensive tasks from the process." +
                " I graduated from Worcester Polytechnic Institute in 2025 with a Bachelor's Degree in Mechanical and Robotics Engineering." +
                " My education, project, and work experience lies in manipulator design, rapid prototyping, robotic controls, aerial manipulators, and machine leaning for computer vision." +
                " I am a jack-of-all-trades and I love working on multiple, cross-discipline aspects of a project, especially when they involve robotic design, control systems, or aerial robotics.",
        exit: "I am experienced in programming and engineering design and I am proficient in many softwares and programming languages" + 
              " such as Solidworks, Github, ROS, ROS2, Ubuntu, Python, Matlab, Java, Javascript, and HTML."
    },
    break: 
        <h1 className="heading">
            <strong className="main-name"> My Recent Experience</strong>
        </h1>,
    workTimeline: [
        {
            id: "work-4",
            title: "Automation Engineer",
            company: "Innofiber",
            description: 
                    <ul>
                        <li>Designed a hands-free automatic polishing device that eliminates 30% of the labor needs from each line it is implemented in</li>
                        <li>Each hands-free polisher costs under $1,000 to make and the multi-modal design meant it was easily adaptable to other flow lines</li>
                        <li>Supported the engineering team and production line by using rapid prototyping to design and create simple fixtures that could be used within a day of needing them</li>
                    </ul>,
            date: "November 2025 - Present",
            icon: <TbAutomaticGearbox/>,
            tags: ["CAD", "Engineering Design", "Rapid Prototyping", "Flowline Design", "Electrical Design", "Microcontroller Programming"]
        },
        {
            id: "work-3",
            title: "TerraWarden Drone Cleanup MQP",
            company: "WPI Senior Project",
            description: 
                    <ul>
                        <li>Worked in a team of 6 to design, manufacture, and build a proof-of-concept aerial manipulator for trash detection and collection on highway medians.</li>
                    </ul>,
            date: "April 2024 - May 2025",
            icon: <GiDeliveryDrone/>,
            tags: ["Deep Learning", "Autonomous Aerial Vehicle", "Aerial Controls", "CAD", "Manipulator Design", "Prototyping"]
        },
        {
            id: "work-2",
            title: "Advanced Manufacturing Engineering Intern",
            company: "TPI Composites/Senvias",
            description:
                    <ul>
                        <li>Assembled design specifications consisting of engineering drawings, safety analysis, and proposed solutions for complex industrial automation processes, such as a rotisserie system designed to raise and rotate composite molds weighing up to 2,000 lbs</li>
                        <li>Developed and improved SOPs for industrial processes such as operation of the industrial oven and safe use of the CNC machines</li>
                    </ul>,

            date: "May 2024 - August 2024",
            icon: <GiMechanicalArm/>,
            tags: ["CAD", "Mechanical Design", "Design Specification", "Prototyping", "Engineering Research", "SOP Writing", "Soldering"]
        },
        {
            id: "work-1",
            title: "Instrumentation and Controls Intern",
            company: "Framatome",
            description:
                    <ul>
                        <li>Implemented full-stack development of a user-friendly application coded in VBA that automatically extracts information from AutoCAD drawings, generates new drawings based on a template, and modifies existing drawing using data from an Access database</li>
                        <li>Documented the development, suggested future improvements, and wrote a step-by-step guide on how to use the tool for new users</li>
                    </ul>,
            date: "May 2023 - August 2023",
            icon: <PiNuclearPlant/>,
            tags: ["AutoCAD", "Microsoft Access", "VBA", "Database Design and Management", "UI design", "System documentation"]
        },
        {
            id: "work-0",
            title: "Peer Tutor",
            company: "WPI Academic Resource Center",
            description:
                    <ul>
                        <li>Tutored groups of 1-15 students in subjects such as mechanics, electricity and magnetism, integral calculus, and multivariable calculus</li>
                        <li>Collaborated with professors, TAs, and other ARC staff to help students achieve maximal understanding of subject material</li>
                    </ul>,
            date: "April 2021 - May 2024",
            icon: <IoMdSchool/>,
            tags: ["Collaboration", "Calculus", "Physics", "Social Skills"]
        }
    ]
}


export default homeConfig